    /* eslint-disable */
    import * as Yup from 'yup';
    import React, { useState, useEffect, useRef } from 'react';
    import {
        Container, Card
    } from '@material-ui/core';

    import { useFormik, Form, FormikProvider } from 'formik';
    import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
    import MenuItem from '@material-ui/core/MenuItem';
    import { useNavigate } from 'react-router-dom';
    import { ToastContainer, toast } from 'react-toastify';
    import Divider from '@material-ui/core/Divider';
    import TableContainer from '@material-ui/core/TableContainer';
    import Paper from '@material-ui/core/Paper';
    import Table from '@material-ui/core/Table';
    import TableHead from '@material-ui/core/TableHead';
    import TableRow from '@material-ui/core/TableRow';
    import TableCell from '@material-ui/core/TableCell';
    import TableBody from '@material-ui/core/TableBody';
    import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
    import TablePagination from '@mui/material/TablePagination';
    import Page from '../../../Page';
    import TokenDecoder from 'src/helpers/TokenDecoder';
    import _ from 'lodash';
    import permissionAuth from 'src/utils/permissionAuth';
    import { trackPromise } from 'react-promise-tracker';
    import { LoadingComponent } from 'src/pages/pageLoader';
    import FirstPageIcon from '@mui/icons-material/FirstPage';
    import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
    import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
    import LastPageIcon from '@mui/icons-material/LastPage';
    import PropTypes, { func } from 'prop-types'
    import { useTheme } from '@mui/material/styles';
    import AdapterDateFns from '@mui/lab/AdapterDateFns';
    import LocalizationProvider from '@mui/lab/LocalizationProvider';
    import DatePicker from '@mui/lab/DatePicker';

    import { makeStyles } from '@material-ui/styles';
    import TableSortLabel from '@material-ui/core/TableSortLabel';
    import CreatePDF from './CreatePDF';
    import ReactToPrint from "react-to-print";
    import xlsx from 'json-as-xlsx';
    import services from '../Services';
    import { Autocomplete } from '@mui/material';

  
    var screenCode = "FARMERWISETRANSACTION"

    function TablePaginationActions(props) {
        const theme = useTheme();
        const { count, page, rowsPerPage, onPageChange } = props;
    
        const handleFirstPageButtonClick = (event) => {
            onPageChange(event, 0);
        };
    
        const handleBackButtonClick = (event) => {
            onPageChange(event, page - 1);
        };
    
        const handleNextButtonClick = (event) => {
            onPageChange(event, page + 1);
        };
    
        const handleLastPageButtonClick = (event) => {
            onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
        };
    
        return (
            <Box sx={{ flexShrink: 0, ml: 2.5 }}>
                <IconButton
                    onClick={handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="first page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="previous page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="next page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="last page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </Box>
        );
    }
    
    TablePaginationActions.propTypes = {
        count: PropTypes.number.isRequired,
        onPageChange: PropTypes.func.isRequired,
        page: PropTypes.number.isRequired,
        rowsPerPage: PropTypes.number.isRequired,
    };
    
    
    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
          return -1;
        }
        if (b[orderBy] > a[orderBy]) {
          return 1;
        }
        return 0;
      }
      
      function getComparator(order, orderBy) {
        return order === 'desc'
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
      }
      
      function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) return order;
          return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
      }
      
    
    const headCells = [
        {
            id: 'farmerName',
            numeric: false,
            disablePadding: false,
            label: 'Farmer Name',
            align: "left"
        },
        {
            id: 'collectionCenter',
            numeric: false,
            disablePadding: false,
            label: 'Collection Center',
            align: "left"
        },
        {
            id: 'product',
            numeric: true,
            disablePadding: false,
            label: 'Product',
            align: "left"
        },
        {
            id: 'orderDate',
            numeric: true,
            disablePadding: false,
            label: 'Date',
            align: "left"
        },
        {
            id: 'quantity',
            numeric: true,
            disablePadding: false,
            label: 'Quantity',
            align: "left"
        },
       
    
    ];

  
    function EnhancedTableHead(props) {
        const { classes, order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
          onRequestSort(event, property);
        };
    
    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align="left"
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
             <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    )
  }

    
  EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
  };
  
  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%'
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2)
    },
    table: {
      minWidth: 750
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1
    }
  }));
 

 export default function FarmerWiseTransaction(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);

    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('date');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  
  const onKeyDown = (e) => {
    e.preventDefault();
 };

  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: true,
    pageheadername: 'Farmer Wise Transaction'
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    
  };  
  
        const [group, setGroup] = useState([]);
        const [factory, setFactory] = useState([]);
        const [farmer, setFarmer] = useState([]);
   
        const [toDate, setToDate] = useState(new Date());
        const [fromDate, setFromDate] = useState(new Date());
        const [farmerWiseTransaction, setFarmerWiseTransaction] = useState([]);
        const [allFarmers, setAllFarmers] = useState([]);

        const [formData, setFormData] = useState({
            groupID: 0,
            operationEntityID: 0,
            farmerID: '',
            fromDate: new Date(fromDate).toISOString(),
            toDate:new Date(toDate).toISOString(),
            isActive: true
        });

        const [permissionList, setPermissions] = useState({
            isGroupFilterEnabled: false,
            isFactoryFilterEnabled: false
        });

        const farmerTransactionSchema = Yup.object().shape({
            groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
            operationEntityID: Yup.number().min(1, 'Please Select Collection Center').required('Collection Center Required'),
            farmerID: Yup.number().min(0, 'Please Select Farmer Name').required('Farmer Name Required'),
            toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
            fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
        });

        const [selectedSearchValues, setSelectedSearchValues] = useState({
            groupID: '',
            operationEntityID: '',
            farmerID:'',
            toDate: '',
            fromDate: ''
        });

        const formik = useFormik({            
            initialValues: {
                groupID: formData.groupID,
                operationEntityID: formData.operationEntityID, 
                farmerID:formData.farmerID,
                fromDate: formData.fromDate,
                toDate: formData.toDate,
                isActive: formData.isActive
            },
            validationSchema: farmerTransactionSchema,
            onSubmit: (values) => {
                values.farmerID!=0?
                trackPromise(SubmitForm())
                : trackPromise(CollectionCenterWiseTransaction(values.operationEntityID, values.fromDate, values.toDate))
            },
        });

        useEffect(() => {
            getPermissions();
        }, []);

        async function getPermissions() {
            var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
            var isAuthorized = permissions.find(p => p.permissionCode == 'FARMERWISETRANSACTION');

            if (isAuthorized === undefined) {
                navigate('/404');
            }

            var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
            var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

            setPermissions({
                ...permissionList,
                isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
                isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
            });

            setValues({
                ...values,
                groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
                operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
            })
            trackPromise(GetAllGroups());
           
        }

        async function SubmitForm() {
            
            let newRes = await services.GetFarmerWiseTransaction(
                formik.values.operationEntityID,
                formik.values.farmerID,
                (fromDate).toISOString(),
                (toDate).toISOString(),

            );
            let final = newRes.filter(x=>x.quantity > 0)
            let res = _.cloneDeep(final);
            res.forEach(x => {
                x.orderDate = x.orderDate.split('T')[0];
            });
            setFarmerWiseTransaction(res);
            createDataForExcel(res);
            getSelectedDropdownVluesForReport();
        }

        async function CollectionCenterWiseTransaction() {
            
            let newRes = await services.CollectionCenterWiseTransaction(
                formik.values.operationEntityID,
                (fromDate).toISOString(),
                (toDate).toISOString(),
            );
            let final = newRes.filter(x=>x.quantity > 0)
            let res = _.cloneDeep(final);
            res.forEach(x => {
                x.orderDate = x.orderDate.split('T')[0];
            });
            setFarmerWiseTransaction(res);
            createDataForExcel(res);
            getSelectedDropdownVluesForReport();
        }


        const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

        useEffect(() => {
            trackPromise(GetAllGroups());
        }, []);

       
        useEffect(() => {
            trackPromise(GetFactoriesByGroupID());
        }, [formik.values.groupID]);
        
        useEffect(() => {
            trackPromise(GetFarmerForDropdownByFactoryID());
        }, [formik.values.operationEntityID]);

       
        async function GetAllGroups() {
            var res = await services.GetAllGroups()
            if (res != null) {
                setGroup(res);
            }
        }

        async function GetFactoriesByGroupID() {
            var res = await services.GetFactoriesByGroupID(formik.values.groupID)
            if (res != null) {
                setFactory(res);
            }
        }

        async function GetFarmerForDropdownByFactoryID() {
            var res = await services.GetFarmerByFactoryIDDropdown(formik.values.operationEntityID)
            if (res != null) {
                setFarmer(res);
                
            }
        }

        async function clearAll() {
            setFarmerWiseTransaction([]);
            formik.resetForm();
        }
        
        function handleSearch(data, e) {
            if (data === undefined || data === null) {
                setValues({
                    ...values,
                    farmerID: '0'
                });
                return;
            } else {
                var valueV = data["farmerID"];
                var valueV2 = data["firstName"];
                var valueV3 = data["lastName"];
    
                setValues({
                    ...values,
                    farmerID: valueV.toString(),
                    farmerName: valueV2 == null ? valueV3.toString() : valueV2.toString()
                });
            }
        }
  
        //Print
        async function createFile() {
            var file = await createDataForExcel(farmerWiseTransaction);
            var settings = {
                sheetName: 'Farmer Wise Transaction',
                fileName: 'Farmer Wise Transaction',
                writeOptions: {}
            }
            let keys = Object.keys(file[0])
            let tempcsvHeaders = csvHeaders;
            keys.map((sitem, i) => {
                tempcsvHeaders.push({ label: sitem, value: sitem })
            })
                let dataA = [
                {
                    sheet: 'Farmer Wise Transaction',
                    columns: tempcsvHeaders,
                    content: file
                }
            ]
            xlsx(dataA, settings);
        }
    
    
        async function createDataForExcel(array) {
            var res = [];
            if (array != null) {
                array.map(x => {
                    var vr = {
                        'Farmer Name': x.firstName,
                        'Collection Center': x.factoryName,
                        'Product': x.productName,
                        'Date ': x.orderDate,
                        'Quantity(Kg) ': x.quantity
                    }
                    res.push(vr);
                });
            }
            return res;
        }
    
        function getSelectedDropdownVluesForReport() {
    
            let groups = group.find(x => x.groupID ==formik.values.groupID)
            let factorys = factory.find(x => x.factoryID==formik.values.operationEntityID)
            setSelectedSearchValues({
                ...selectedSearchValues,
                groupID: groups.groupName,
                operationEntityID: factorys.factoryName,
                
                
            });
        }
      
        return (
            <>
                <LoadingComponent />
                <Page title="Farmer Wise Transaction |  FAPS">
                    <Container>
                        <CommonPageHeader
                            path={"/farmerCropWiseTransaction"}
                            btname="Add"
                            pageName="Farmer Wise Transaction"
                            leftButtonHidden={true}
                        />
                        <FormikProvider value={formik}>
                            <ToastContainer
                                position="bottom-right"
                                pauseOnHover
                            />
                             <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                                <Stack spacing={2}>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Group *"
                                            value={formik.values.groupID}
                                            onChange={formik.handleChange}
                                            {...getFieldProps('groupID')}
                                            error={Boolean(touched.groupID && errors.groupID)}
                                            helperText={touched.groupID && errors.groupID}
                                            InputProps={{
                                                readOnly: !permissionList.isGroupFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}>Select Group</MenuItem>
                                            {group.map((option) => (
                                                option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                    {option.groupName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField>
                                        <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Collection Center *"
                                            value={formik.values.operationEntityID}
                                            onChange={formik.operationEntityID}

                                            {...getFieldProps('operationEntityID')}
                                            error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                            helperText={touched.operationEntityID && errors.operationEntityID}
                                            InputProps={{
                                                readOnly: !permissionList.isFactoryFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}>Select Collection Center</MenuItem>
                                            {factory.map((option) => (
                                                option.isActive == true ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                    {option.factoryName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField>
                                    <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            label="Farmer *"
                                            value={formik.values.farmerID}
                                            onChange={formik.farmerID}

                                            {...getFieldProps('farmerID')}
                                            error={Boolean(touched.farmerID && errors.farmerID)}
                                            helperText={touched.farmerID && errors.farmerID}
                                            InputProps={{
                                                readOnly: !permissionList.isFactoryFilterEnabled
                                            }}
                                        >
                                            <MenuItem key={0} value={0}>All Farmers</MenuItem>
                                            {farmer.map((option) => (
                                                option.isActive == true ? <MenuItem key={option.farmerID} value={option.farmerID}>
                                                    {option.givenName}
                                                </MenuItem> : null
                                            ))}
                                        </TextField>

                                         
                                            </Stack>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Start Date"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}

                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}

                                                {...params} />}
                                                
                                               
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select End Date"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}

                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}
                                             {...params} />}
                                             

                                        />
                                    </LocalizationProvider>
                                    </Stack>
                                    </Stack>
                                <br />
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        color='error'
                                        onClick={() => clearAll()}
                                    > Clear</Button>
                                    <Button
                                        type="submit"
                                        color='secondary'
                                        variant="outlined"
                                    >Search</Button>
                                </Stack>
                           
                        <br /><Divider variant="middle" /><br />
                        <>
                        {farmerWiseTransaction.length != 0 ? (
                                        <>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                                <Card style={{ justifycontent: 'center', width: '100rem' }}>
                                                    <Paper className={classes.paper}>
                                                         <TableContainer>
                                                         <Table
                                                            className={classes.table}
                                                            aria-labelledby="tableTitle"
                                                            aria-label="enhanced table"
                                                            >
                                                            <EnhancedTableHead
                                                                classes={classes}
                                                                order={order}
                                                                orderBy={orderBy}
                                                                onRequestSort={handleRequestSort}
                                                                rowCount={farmerWiseTransaction.length}
                                                            />
                                                            <TableBody>
                                                                {stableSort(farmerWiseTransaction, getComparator(order, orderBy))
                                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                .map((row, index) => {
                                                                    const labelId = `enhanced-table-checkbox-${index}`;

                                                                            return (
                                                                                <TableRow>
                                                                                    <TableCell component="th" id={labelId} scope="row" >
                                                                                        {row.firstName}
                                                                                     </TableCell>
                                                                                     <TableCell >{row.factoryName}</TableCell>
                                                                                    <TableCell >{row.productName}</TableCell>
                                                                                    <TableCell >{row.orderDate}</TableCell>
                                                                                    <TableCell >{row.quantity}</TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        })}
                                                                </TableBody>      
                                                            </Table>
                                                        </TableContainer>

                                                        <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25]}
                                                            component="div"
                                                            count={farmerWiseTransaction.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onPageChange={handleChangePage}
                                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                                        />
                                                    </Paper>
                                                </Card>
                                            </Stack>
                                        </>
                                    ) : null}</>
                   </Form>
                    </FormikProvider>
                    {farmerWiseTransaction.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Farmer Wise Transaction Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    productList={farmerWiseTransaction}
                                    searchData={selectedSearchValues}

                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}